import { apiClient } from './apiClient';

const getPublicSiteContent = () => apiClient.fetchJson('/api/public/site-content');

const getPropertyBySlug = (propertySlug) => apiClient.fetchJson(`/api/public/properties/${propertySlug}`);

const getAdminSession = () => apiClient.fetchJson('/api/admin/session');

const getAdminDashboard = () => apiClient.fetchJson('/api/admin/dashboard');

const login = (credentials) =>
  apiClient.fetchJson('/api/admin/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  });

const logout = () =>
  apiClient.fetchJson('/api/admin/logout', {
    method: 'POST',
  });

const saveProperty = (property, editingSlug) =>
  apiClient.fetchJson(editingSlug ? `/api/admin/properties/${editingSlug}` : '/api/admin/properties', {
    method: editingSlug ? 'PUT' : 'POST',
    body: JSON.stringify(property),
  });

const deleteProperty = (slug) =>
  apiClient.fetchJson(`/api/admin/properties/${slug}`, {
    method: 'DELETE',
  });

const uploadPropertyImage = (file) => {
  const formData = new FormData();
  formData.append('image', file);

  return apiClient.uploadFile('/api/admin/properties/upload', formData);
};

const updateSettings = (settings) =>
  apiClient.fetchJson('/api/admin/settings', {
    method: 'PUT',
    body: JSON.stringify(settings),
  });

const submitInquiry = (inquiry) =>
  apiClient.fetchJson('/api/public/inquiries', {
    method: 'POST',
    body: JSON.stringify(inquiry),
  });

export const siteApi = {
  getPublicSiteContent,
  getPropertyBySlug,
  getAdminSession,
  getAdminDashboard,
  login,
  logout,
  saveProperty,
  deleteProperty,
  uploadPropertyImage,
  updateSettings,
  submitInquiry,
};